'use client'

import React from 'react'
import Link from 'next/link'
import Footer from '@/components/footer'
import Navigation from '@/components/navigation'
import Contact from '@/components/contact'

export default function PrivacyPage(): React.ReactElement {
  return (
    <>
      <Navigation solid />
      <div className="container mx-auto px-4 py-8 min-h-screen mt-24">
        <div className="max-w-3xl mx-auto">
          <div className="relative mb-8">
            <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight text-white mb-4">
              Privacy Policy
            </h1>
            <div className="h-1 w-16 bg-amber-500"></div>
          </div>

          <div className="prose prose-invert max-w-none">
            <div className="space-y-8">
              <section className="bg-slate-900/50 border border-slate-800 rounded-xl p-6 sm:p-8 hover:border-slate-700 transition-colors">
                <h2 className="text-xl sm:text-2xl font-bold tracking-tight text-white mb-4">Overview</h2>
                <p className="text-base sm:text-lg text-white/80">
                  This Privacy Policy describes how your personal information is collected, used, and shared when you visit or interact with this website (the "Site").
                </p>
              </section>

              <section className="bg-slate-900/50 border border-slate-800 rounded-xl p-6 sm:p-8 hover:border-slate-700 transition-colors">
                <h2 className="text-xl sm:text-2xl font-bold tracking-tight text-white mb-4">Information We Collect</h2>
                <div className="space-y-4">
                  <div>
                    <h3 className="text-lg sm:text-xl font-bold text-white mb-2">Personal Information</h3>
                    <p className="text-base sm:text-lg text-white/80">
                      We may collect personal information you provide, such as your name, email address, and any other details submitted through contact forms or newsletter sign-ups.
                    </p>
                  </div>
                  <div>
                    <h3 className="text-lg sm:text-xl font-bold text-white mb-2">Usage Data</h3>
                    <p className="text-base sm:text-lg text-white/80">
                      We automatically collect certain information about your device and how you interact with the Site, including your IP address, browser type, referring/exit pages, and usage patterns. This may be collected via cookies or analytics tools.
                    </p>
                  </div>
                </div>
              </section>

              <section className="bg-slate-900/50 border border-slate-800 rounded-xl p-6 sm:p-8 hover:border-slate-700 transition-colors">
                <h2 className="text-xl sm:text-2xl font-bold tracking-tight text-white mb-4">How We Use Your Information</h2>
                <ul className="list-disc ml-4 sm:ml-6 space-y-2 text-base sm:text-lg text-white/80">
                  <li>To respond to your inquiries or requests</li>
                  <li>To improve and optimize the Site</li>
                  <li>To send updates or newsletters (if you opt in)</li>
                  <li>To comply with legal obligations</li>
                </ul>
              </section>

              <section className="bg-slate-900/50 border border-slate-800 rounded-xl p-6 sm:p-8 hover:border-slate-700 transition-colors">
                <h2 className="text-xl sm:text-2xl font-bold tracking-tight text-white mb-4">Cookies & Third-Party Services</h2>
                <div className="space-y-4">
                  <p className="text-base sm:text-lg text-white/80">
                    We may use cookies and similar tracking technologies to analyze website traffic and enhance your experience. You can disable cookies in your browser settings, but some features may not function properly.
                  </p>
                  <p className="text-base sm:text-lg text-white/80">
                    We may use third-party services (such as analytics providers or email marketing platforms) that collect, monitor, and analyze usage data. These providers have their own privacy policies regarding the information they collect.
                  </p>
                </div>
              </section>

              <section className="bg-slate-900/50 border border-slate-800 rounded-xl p-6 sm:p-8 hover:border-slate-700 transition-colors">
                <h2 className="text-xl sm:text-2xl font-bold tracking-tight text-white mb-4">Your Rights & Security</h2>
                <div className="space-y-4">
                  <div>
                    <h3 className="text-lg sm:text-xl font-bold text-white mb-2">Data Security</h3>
                    <p className="text-base sm:text-lg text-white/80">
                      We take reasonable measures to protect your personal information, but no method of transmission over the Internet or electronic storage is 100% secure.
                    </p>
                  </div>
                  <div>
                    <h3 className="text-lg sm:text-xl font-bold text-white mb-2">Your Rights</h3>
                    <ul className="list-disc ml-4 sm:ml-6 space-y-2 text-base sm:text-lg text-white/80">
                      <li>You may request access to, correction of, or deletion of your personal information</li>
                      <li>You may opt out of marketing communications at any time</li>
                    </ul>
                  </div>
                </div>
              </section>

              <section className="bg-slate-900/50 border border-slate-800 rounded-xl p-6 sm:p-8 hover:border-slate-700 transition-colors">
                <h2 className="text-xl sm:text-2xl font-bold tracking-tight text-white mb-4">Updates & Contact</h2>
                <div className="space-y-4">
                  <p className="text-base sm:text-lg text-white/80">
                    We may update this Privacy Policy from time to time. Changes will be posted on this page with an updated effective date.
                  </p>
                  <p className="text-base sm:text-lg text-white/80">
                    If you have any questions about this Privacy Policy, please use the contact form on this website.
                  </p>
                  <p className="text-sm text-white/60 mt-4">Effective date: April 17, 2025</p>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
      <Contact />
      <Footer />
    </>
  );
}
